var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowToRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9,
    cy: 10,
    r: 9,
    fill: "#775D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8678 9.67938L25.3225 5.13399C25.1592 4.94333 24.8722 4.9211 24.6816 5.08442C24.4909 5.2477 24.4687 5.53464 24.632 5.7253C24.6472 5.74308 24.6638 5.75968 24.6816 5.77487L28.4497 9.54754H10.4545C10.2035 9.54754 10 9.75105 10 10.0021C10 10.2532 10.2035 10.4566 10.4545 10.4566H28.4497L24.6816 14.2247C24.4909 14.388 24.4687 14.675 24.632 14.8656C24.7953 15.0563 25.0822 15.0785 25.2729 14.9152C25.2907 14.8999 25.3073 14.8834 25.3225 14.8656L29.8679 10.3202C30.0441 10.143 30.0441 9.85668 29.8678 9.67938Z",
    fill: "#FCF9CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight);
export default __webpack_public_path__ + "static/media/ArrowToRight.bc11e63986aa0499a643a6cb9ca3d05c.svg";
export { ForwardRef as ReactComponent };